export default {
  heading:
    'Neque porro quisquam est colorem ipsum quia dolor amet, consectetur, pisci velit.',
  heading_size: 'h2',
  battenberg: [
    {
      title: 'Tribal Health',
      square_1: { color: 'transparent' },
      square_2: { color: '#FFFFFF' },
      square_3: { color: 'transparent' },
      square_4: { color: '#FFFFFF' },
      square_5: { color: 'transparent' },
      square_6: { color: 'transparent' },
      square_7: { color: 'transparent' },
      square_8: { color: '#FFFFFF' },
      square_9: { color: '#FFFFFF' },
      component: 'a-svg-logo-x9',
    },
  ],
  component: 'o-health-text-hero',
}
